<div class="login-container">
  <h4 class="heading font-bureau font-medium">Sign in to your account</h4>

  <form [formGroup]="form" (ngSubmit)="submit()" class="login-form auth-form-wrapper">
    <app-text-input
      label="Email"
      [error]="errorMessages['email']"
      placeholder="Email"
      [parentFormGroup]="form"
      controlName="email"
      (checkForErrors)="checkForErrors($event)"
    />

    @if(showOtp()) {
      <div class="verification-message">
        We've sent a verification code to your email address.
        Please enter the 6-digit code below to verify your account.
      </div>

      <app-otp-input
        [parentFormGroup]="otpForm"
        controlName="otp"
        label="Verification Code"
        [error]="errorMessages['otp']"
        placeholder="0"
        (checkForErrors)="checkForOtpErrors($event)"
      />
    } @else {
      <app-password-input
        label="Password"
        [error]="errorMessages['password']"
        placeholder="Password"
        [parentFormGroup]="form"
        controlName="password"
        (checkForErrors)="checkForErrors($event)"
        [showHint]="false"
      />

      <div class="forgot-password">
        <a
          href="/forgot-password"
          class="font-geist font-regular"
        >Forgot password?</a>
      </div>
    }

    <app-primary-button
      class="submit-button"
      [isLoading]="(isLoading$ | async)"
      [isDisabled]="(isLoading$ | async)"
      (handleClick)="showOtp() ? submitOtp() : submit()"
    >
      {{showOtp() ? 'Verify code' : 'SIGN IN'}}
    </app-primary-button>

  </form>
  <div class="signup-prompt font-geist font-regular">
    New to NeuralOps? <a href="/signup">Get Started</a>
  </div>
  <div class="copyright font-geist font-regular">
    © 2025 NeuralOps. All rights reserved.
  </div>
</div>
